import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReceivablesReconciliationListItem = ResultOf<
  typeof receivablesReconciliationQuery
>["receivablesReconciliation"][number];
export const receivablesReconciliationQuery = graphql(`
  query ReceivablesReconciliation($asOfDate: String!) {
    receivablesReconciliation(as_of_date: $asOfDate) {
      contact_id
      contact_name
      currency
      total_invoiced
      total_payments
      total_credits
      total_refunds
      amount_due
    }
  }
`);

export const receivablesReconciliationSummaryQuery = graphql(`
  query ReceivablesReconciliationSummary($asOfDate: String!) {
    receivablesReconciliationSummary(as_of_date: $asOfDate) {
      currency
      total_amount_due
      total_invoiced
      total_payments
      total_credits
      total_refunds
      account_count
    }
  }
`);
